module.exports = __webpack_public_path__ + "static/media/type.35e2169a.svg";